var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64088 5.00024L3.05539 2.41475C2.66486 2.02423 2.58572 1.47021 2.87861 1.17732C3.17151 0.884424 3.72552 0.963569 4.11605 1.35409L6.94448 4.18252C7.18777 4.42581 7.31021 4.73256 7.29713 5.00009C7.31031 5.26769 7.18787 5.57457 6.94449 5.81795L4.11606 8.64637C3.72554 9.0369 3.17152 9.11604 2.87863 8.82315C2.58573 8.53026 2.66488 7.97624 3.0554 7.58571L5.64088 5.00024Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight1);
export default __webpack_public_path__ + "static/media/arrow-right_1.6b44082cb4bcef76d0cad57bb1762d20.svg";
export { ForwardRef as ReactComponent };